<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Detalle del Album`,
        },
      ]"
    />
    <div v-if="loading" class="text-center">
      <Loader />
    </div>

    <div v-else>
      <div class="card ml-3 mr-3 mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <!-- LATITUD -->
              <div class="form-group">
                <label>Nombre album</label>
                <input
                  v-if="galery != null"
                  type="text"
                  v-model="galery.album.Title"
                  :class="`form-control `"
                />
                <button
                  v-if="galery != null"
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="removeAlbum(galery.album.Id)"
                >
                  Eliminar album
                </button>
                <button
                  v-if="galery != null"
                  class="btn btn-outline-primary"
                  type="button"
                  @click="updateAlbum(galery.album.Id)"
                >
                  Actualizar album
                </button>
              </div>
            </div>
            <div class="col-sm-6">
              <label>Imagen de portada</label>
              <div class="card mb-3" style="width: 80%; height: 350px">
                <img
                  v-if="albumFile == null"
                  @click="handleFileChangeAlbum"
                  class="card-img-top"
                  :src="galery.album.FileLocation"
                  style="
                    width: 100%;
                    height: 350px;

                    cursor: pointer;
                  "
                />
                <img
                  v-else
                  @click="handleFileChangeAlbum"
                  class="card-img-top"
                  :src="getMediaUrl(albumFile)"
                  style="width: 100%; height: 350px; cursor: pointer"
                />

                <div class="card-body">
                  <button
                    v-if="albumFile"
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="removeMediaAlbum()"
                  >
                    Eliminar
                  </button>
                  <input
                    type="file"
                    class="custom-file-input"
                    ref="fileInputAlbum"
                    @change="handleFileChangeAlbum"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- aqui van las medias -->
      <div class="card ml-3 mr-3 mt-3">
        <label class="ml-3 mt-3 title"> Media</label>
        <div class="card-body">
          <div class="row">
            <div
              class="col-md-4"
              v-for="(media, index) in galery.stories"
              :key="index"
            >
              <div class="card mb-3" style="width: 80%; height: 255px">
                <img
                  v-if="media.typeOfFile == 'img'"
                  class="card-img-top"
                  :src="media.FileLocation"
                  style="width: 100%; height: 200px"
                />
                <img
                  v-else
                  class="card-img-top"
                  src="../../assets/video.jpg"
                  style="width: 100%; height: 200px"
                />
                <button
                  v-show="file == null"
                  class="btn btn-outline-primary"
                  type="button"
                  @click="goToDetailMedia(media.Id)"
                >
                  detalle <i class="fa fa-edit"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  components: {
    Loader,
    Breadcrumbs,
  },
  data() {
    return {
      galery: null, // Initial media list with one empty item
      albumFile: null,
      companyService: new CompanyService(),
      title: "",
      loading: false,
    };
  },
  mounted: async function () {
    this.getGalery();
  },
  methods: {
    goToDetailMedia(id) {
      this.$router.push({ name: "detail-media", params: { id: id } });
    },
    async updateAlbum() {
      try {
        Swal.fire({
          title: "Esta seguro de actualizar el album?",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Actualizar",
          denyButtonText: `Don't save`,
        }).then(async (result) => {
          if (result.dismiss != "cancel") {
            this.loading = true;
            let galeryBase64 =
              this.albumFile != null
                ? await this.fileToBase64(this.albumFile)
                : "";

            var data = {
              id: this.galery.album.Id,
              title: this.galery.album.Title,
              file:
                this.albumFile != null
                  ? galeryBase64
                  : this.galery.album.FileLocation,
              documentName:
                this.albumFile != null
                  ? this.albumFile.name
                  : this.galery.album.fileName,
            };
            const res = await this.companyService.updateAlbum(data);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Se ha actualizado correctamente.",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          this.loading = false;
          this.getGalery();
        });
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async removeAlbum(id) {
      try {
        Swal.fire({
          title: "Esta seguro de eliminar el album?",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          denyButtonText: `Don't save`,
        }).then(async (result) => {
          if (result.dismiss != "cancel") {
            this.loading = true;
            const res = await this.companyService.deleteGalery(id);
            if (res.ok) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Se ha eliminado correctamente.",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.go(-1);
            }
          }
          this.loading = false;
        });
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    addMedia() {
      this.mediaList.push({ file: null });
    },
    async getGalery() {
      try {
        this.loading = true;
        const res = await this.companyService.getGalery(this.$route.params.id);
        this.galery = res.data;

        this.loading = false;
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },

    handleFileChangeAlbum() {
      this.$refs.fileInputAlbum.click();
      const input = this.$refs.fileInputAlbum;
      if (input && input.files.length > 0) {
        this.albumFile = input.files[0];
      }
    },

    getMediaUrl(file) {
      console.log("file", file);
      return URL.createObjectURL(file);
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.split(",")[1]);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style>
/* Add custom styles here if needed */
</style>
